// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

console.log('got this far');

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
});

// on load promise
window.loaded = new Promise((resolve) => {
    window.addEventListener('load', () => resolve(window))
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js